import { Link } from "react-router-dom";
import { TOPICS } from "@/components/TopicPicker";
import { ArrowRight } from "lucide-react";

const IMG = {
  ai: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "real-estate": "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  insurance: "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  loans: "https://images.unsplash.com/photo-1631511258193-252ab3da6b8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export default function Industries() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-20" data-testid="industries-page">
      <div className="asf-overline mb-3">Explore</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-10">Choose your industry</h1>
      <div className="grid sm:grid-cols-2 gap-6">
        {TOPICS.map((t) => (
          <div key={t.slug} className="asf-card overflow-hidden group" data-testid={`industry-tile-${t.slug}`}>
            <div className="relative h-52 overflow-hidden">
              <img src={IMG[t.slug]} alt={t.label} className="h-full w-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-asf-elevated via-asf-elevated/40 to-transparent" />
              <h2 className="absolute bottom-4 left-6 font-display text-3xl font-bold">{t.label}</h2>
            </div>
            <div className="p-6 flex items-center justify-between">
              <p className="text-slate-500">{t.desc}</p>
              <div className="flex gap-2">
                <Link to={`/courses/${t.slug}`} className="btn-secondary px-4 py-2 text-sm">Courses</Link>
                <Link to={`/webinars/${t.slug}`} className="btn-primary px-4 py-2 text-sm flex items-center gap-1">Webinar <ArrowRight className="h-4 w-4" /></Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
